import {useMutation} from '@tanstack/react-query'
import {PostSiemS3IntegrationAction} from 'interfaces'
import {SIEMService} from 'services/api'

interface UseCreateSiemS3IntegrationMutationProps {
  refetchSiemIntegration: () => void
}
export const useCreateSiemS3IntegrationMutation = ({
  refetchSiemIntegration,
}: UseCreateSiemS3IntegrationMutationProps) => {
  return useMutation({
    mutationFn: (payload: PostSiemS3IntegrationAction) =>
      SIEMService.postSiemS3Integration(payload),
    onSuccess: () => {
      // on success refetch the SIEM setting data
      refetchSiemIntegration()
    },
  })
}

interface UseDeleteSiemS3IntegrationMutationProps {
  refetchSiemIntegration: () => void
}
export const useDeleteSiemS3IntegrationMutation = ({
  refetchSiemIntegration,
}: UseDeleteSiemS3IntegrationMutationProps) => {
  return useMutation({
    mutationFn: () => SIEMService.deleteSiemS3Integration(),
    onSuccess: () => {
      // on success refetch the SIEM setting data
      refetchSiemIntegration()
    },
  })
}
